const $ = require('jquery');

const SmoothParallax = require('../../node_modules/smooth-parallax/dist/smooth-parallax.min.js');

// const Headroom = require('../../node_modules/headroom.js/dist/headroom.min.js');
// const jQueryHeadroom = require('../../node_modules/headroom.js/dist/jQuery.headroom.min.js');

window.jquery = $;
window.jQuery = $;
window.$ = $;

// Popper is a pre-requisite for bootstrap 4 drop-downs.
const popper = require('popper.js');

window.Popper = popper;

require('bootstrap');
require('lity');

function threeColWrapper() {
  let layoutClass = 'col-11 offset-1';

  if ($(this).hasClass('has-sidebar')) {
    layoutClass = 'col-12';
  }
  return `
    <div class="multi-col-wrapper ${layoutClass}">
      <div class="container">
        <div class="row no-gutters">
          <div class="d-flex col-12 col-lg-9 col-xl-8 offset-lg-2 offset-xl-2">
            <div class="row">

            </div>
          </div>
        </div>
      </div>
    </div>`;
}

// Generate Pseudo Random String, if safety is important use
// dedicated crypto/math library for less possible collisions!
function generateId(length) {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

function showMoreWrapper(id) {
  return `
    <div class="collapse" id="collapse${id}">

    </div>`;
}

((window, document) => {
  const f = {
    addToCartInList: (el) => {
      const $el = $(el.delegateTarget);
      const $form = $el.parents('li.product-item').find('form').get(0);
      if ($form) {
        $form.submit();
      }
    },
  };

  $(document).ready(() => {
    $('[data-action="cart"]').on('click', (el) => {
      f.addToCartInList(el);
    });

    $('.paragraph--type--section').each((el) => {
      $(el)
        .find('.content-3-col')
        .first()
        .siblings('.content-3-col')
        .addBack()
        .wrapAll(threeColWrapper);
    });

    $('.paragraph--type--featured-content-block').each((i, el) => {
      const firstParagraph = $(el).find('.field--name-field-body :first-child')[0];
      if (!$(firstParagraph).hasClass('show-more-processed')) {
        const id = generateId(4);
        const link = `
    <a class="btn btn-outline-dark btn-arrow-down featured-content-block featured-content-block-show-more" data-toggle="collapse" href="#collapse${id}" role="button" aria-expanded="false" aria-controls="collapse${id}">
      Show more
    </a><a class="btn btn-outline-dark btn-arrow-up featured-content-block featured-content-block-show-less" data-toggle="collapse" href="#collapse${id}" role="button" aria-expanded="false" aria-controls="collapse${id}">
      Show less
    </a>`;
        $(firstParagraph).addClass('show-more-processed');
        const $siblings = $(firstParagraph).siblings();
        if ($siblings.length > 0) {
          $siblings.wrapAll(showMoreWrapper(id));
          $(firstParagraph).parent('.field--name-field-body').find('.collapse').after(link);
        }
      }
    });

    // listent to hover over
    $('.mega-menu').hover(null,
      (el) => {
        const aId = $(el.target).parent('li').find('>a');
        aId.trigger('click');
      });

    // Mobile Menu child items click.
    $('.mega-menu li').on('click', 'button.mega-menu-expend', (e) => {
      const bt = $(e.target);
      const openedItem = $('.mega-menu li.opened');
      const clickedItem = bt.parents('.mega-item');

      if (clickedItem.hasClass('opened')) {
        clickedItem.removeClass('opened');
      }
      else {
        openedItem.removeClass('opened');
        clickedItem.addClass('opened');
      }
    });

    $('#block-law-society-main-main-menu .top-level li').on('click', 'button.mega-menu-expend', (e) => {
      const bt = $(e.target);
      const openedItem = $('#block-law-society-main-main-menu li.show');
      const clickedItem = bt.parents('.nav-item');

      if (clickedItem.hasClass('show')) {
        clickedItem.removeClass('show');
      }
      else {
        openedItem.removeClass('show');
        clickedItem.addClass('show');
      }
    });
  });

  window.addEventListener('load', () => {
    SmoothParallax.init();
    const menuCollapse = '.search-block, #CollapsingNavbar';

    $(menuCollapse).on('shown.bs.collapse', () => {
      $('.menu-mask').addClass('show-as-das');
      $('body').addClass('mega-menu-open');
    });

    $(menuCollapse).on('hidden.bs.collapse', () => {
      $('.menu-mask').removeClass('show');
      $('body').removeClass('mega-menu-open');
    });
  });

  // Prevent menu toggle from being opened if search is already opened.
  $('.hamburger-container .navbar-toggler').on('click', (e) => {
    const isMobile = $(window).width() < 1200;
    const searchIsOpened = $('body').hasClass('mega-menu-open');
    const menuIsOpened = $('#CollapsingNavbar').hasClass('show') || $('#CollapsingNavbar').hasClass('collapsing');

    if (isMobile && searchIsOpened && !menuIsOpened) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Prevent search toggle from being opened if menu is already opened.
  $('.search-toggle').on('click', (e) => {
    const menuIsOpened = $('#CollapsingNavbar').hasClass('show') || $('#CollapsingNavbar').hasClass('collapsing');

    if (menuIsOpened) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
})(window, document);
